<template>
    <div class="vheader-box">
        <div class="vheader">
            <img src="../assets/img/logo2x.png" alt="">
            <router-link v-for="(item,idx) in router" :key="idx" :to='item.to' class="link" :class="idx==index?'active':''" @click.native="activetag(item,idx)">{{item.title}}</router-link>
            <span>Welcome To SEALYYG</span>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            router:[
                {title:'首页',to:'/'},
                {title:'案例',to:'/cases'}
            ],
            index:0,
        }
    },
    methods :{
        activetag(item,idx){
            this.index = idx
        },
    }
}
</script>
<style lang="less" scoped>
    .vheader-box{
        width: 100%;
        height: 80px;
        box-sizing: border-box;
        display: flex;
        background: none;
        margin-bottom: -80px;
        .vheader{
            height: 80px;
            width: 1330px;
            display: flex;
            align-items: center;
            position: absolute;
            top: 0;
            left: 0;
            right: 0; 
            margin: auto;
            z-index: 99;
            img{
                width: 180px;
                height: 35px;
                margin-right: 50px;
            }
            span{
                margin-left: auto;
                color: #becaff;
            }
            a{
                height: 34px;
                width: 80px;
                display: block;
                text-align: center;
                line-height: 30px;
                text-decoration: none;
                margin-right: 20px;
                color:#becaff;
                font-size: 15px;
                font-family: SourceHanSansCN-Medium;
                box-sizing: border-box !important;
                font-weight: Medium;
                // border: #243E9F 1px solid;
                border-radius: 17px;
                // &.router-link-active{
                //     border-radius: 17px;
                //     border:1px solid rgba(74,110,212,1);
                //     box-sizing: border-box
                // }
            }
            a:hover{
                color: white;
            }
            .active{
                border-radius: 17px;
                border:1px solid rgba(74,110,212,1);
                box-sizing: border-box;
                color: #ffffff;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/vheader.vue